/* eslint-disable no-undef */
import React, { useState, Fragment, useEffect, useMemo } from 'react';
import {
  Collapse, Upload, Steps, Table,
  Select,
  Tooltip,
  Drawer,
  DatePicker,
  Popconfirm,
  notification,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  faAngleDown, faAngleRight, faCircleCheck, faCircleInfo, faTrashCan, faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import './style.scss';
import { v4 as uuidv4 } from 'uuid';
import {
  EditFilled, InboxOutlined,
  LockOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import ProductActions from '@Actions/productActions';
import H3Text from '@Uilib/h3Text';
import OCRActions from '@Actions/ocrActions';
import Constants, {
  toISTDate,
} from '@Apis/constants';
import AddressSelector from '@Components/Common/FormUtils/AddressSelecter';
import ProductFilterV2 from '@Components/Common/ProductFilterV2';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import Ai from '@Images/ai.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import SellerActions from '@Actions/sellerActions';
import Lottie from 'lottie-react';
import CustomerActions from '@Actions/customerActions';
import SettingsInfo from '@Components/Common/SettingsInfo';
import OCRLoader from './OCRLoader';
import SelectSeller from '../SelectSeller';
import inventoryLocationActions from '../../../actions/settings/inventoryLocationActions';
import restrictedLock from '../../../media/lotties/restrictedLock.json';
import SelectCustomer from '../SelectCustomer';
import documentUINamesConstant from '../../../apis/documentUINamesConstant';
import { GetPurchaseOrders } from '@Modules/purchase/purchaseOrder';
import PRZSelect from '../UI/PRZSelect';

const { Step } = Steps;
const { Panel } = Collapse;
const { Dragger } = Upload;
const { Option } = Select;

const OCRFileUploader = ({
  user, uploadDocumentOCR, uploadDocumentOCRLoading, entityName, getCustomers, getPurchaseOrdersV2,
  purchaseOrdersV2, MONEY, history, getInventoryLocations, getSellers, searchProductsLoading, searchProducts,
}) => {
  const [fileListOcr, setFileListOcr] = useState([]);
  const [dataFromOCR, setDataFromOCR] = useState([]);
  const [selectedPoValue, setSelectedPoValue] = useState(null);
  const [activeKey, setActiveKey] = useState(['1']);
  const [vendorAddress, setVendorAddress] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [billingAddress, setBillingAddress] = useState(null);
  const [selectedAddressType, setSelectedAddressType] = useState(null);
  const [showAddressDrawer, setShowAddressDrawer] = useState(false);
  const [grnDate, setGrnDate] = useState();
  const [gstNumber, setGstNumber] = useState('');
  const [successStep, setSuccessStep] = useState([]);
  const [selectedPo, setSelectedPo] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [call, setCall] = useState(false);
  const [callCustomer, setCallCustomer] = useState(false);
  const [orderDate, setOrderDate] = useState();
  const [deliveryDate, setDeliveryDate] = useState();

  const isOcrIsPremiumFeature = user?.tenant_info?.global_config?.sub_modules?.automatic_document_scan?.is_active;
  const isAdhocGrnIsEnabled = user?.tenant_info?.config__grn__allow_adhoc;

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  useEffect(() => {
    getInventoryLocations(selectedPo?.tenant_department_id || user?.tenant_info?.default_store_id, '', null, true, null, null, (locations) => {
      setSelectedLocation(locations);
    });
  }, [selectedPo]);

  const handleProductChange = (value, key) => {
    const updatedData = dataFromOCR?.map((item) => {
      const copyData = JSON.parse(JSON.stringify(item.data));
      const newData = copyData?.map((product) => {
        if (product.product_name === key) {
          // Remove the previously selected option from the selectedOptions array
          if (product.product_sku_id && product.product_sku_id !== value?.product_sku_id) {
            setSelectedOptions((prevSelectedOptions) => prevSelectedOptions.filter(
              (optionId) => optionId !== product.product_sku_id,
            ));
          }

          if (value) {
            // Add the newly selected option to the selectedOptions state
            setSelectedOptions((prevSelectedOptions) => [
              ...prevSelectedOptions,
              value?.product_sku_id,
            ]);
          } else {
            // Remove the option from the selectedOptions state when clearing the value
            setSelectedOptions((prevSelectedOptions) => prevSelectedOptions.filter(
              (optionId) => optionId !== product.product_sku_id,
            ));
          }

          return {
            product_sku_info: value,
            mapped: !!value,
            product_sku_name: value?.alias_name || value?.product_sku_name || null,
            quantity: product?.quantity,
            unit_price: product?.unit_price,
            product_name: product?.product_name || null,
            old_orc_data: product,
            product_sku_id: value?.product_sku_id || null,
          };
        }
        return product;
      });
      return {
        ...item,
        tenantDepartmentId: selectedPo?.tenant_department_id || user?.tenant_info?.default_store_id,
        selectedPo,
        data: newData,
      };
    });
    setDataFromOCR(updatedData);
  };

  const handleDelete = (key) => {
    const updatedData = dataFromOCR?.map((item) => {
      const copyData = JSON.parse(JSON.stringify(item.data));
      if (copyData?.length === 1) {
        notification.error({
          message: 'At least one product is required',
          placement: 'top',
          duration: 4,
        });
        return item;
      }
      const newData = copyData?.filter((product) => product.product_name !== key);
      return {
        ...item,
        data: newData,
      };
    });

    setDataFromOCR(updatedData);
  };

  // transform data for create grn
  const transformDataForCreateGRN = (ocrData) => {
    getInventoryLocations(user?.tenant_info?.default_store_id, '', null, true);
    const grnData = {
      tenant_id: user?.tenant_info?.tenant_id,
      invoice_number: ocrData?.[0]?.invoice_number,
      selectedSeller: ocrData?.[0]?.seller_details?.newSeller,
      selectedAddressType: 'SELLER',
      vendorAddress,
      grn_lines: ocrData?.[0]?.data?.map((item) => ({
        ...item?.product_sku_info,
        quantity: item?.quantity || 0,
        offer_price: item?.unit_price,
        old_orc_data: item?.old_orc_data,
        received_qty: item?.quantity || 0,
        product_info: item?.product_sku_info?.product_sku_info || item?.product_sku_info?.product_info,
        selectedLocation: selectedLocation?.inventory_location,
      })),
      invoice_date: dayjs(grnDate).format('DD-MM-YYYY'),
      gst_number: gstNumber,
      selectedPoValue,
      grnTypeValue: selectedPoValue ? 'Purchase Order' : 'ADHOC',
      // selectedPo: ocrData?.[0]?.selectedPo,
      selectedPo,
      tenantDepartmentId: ocrData?.[0]?.tenantDepartmentId,
      ocrDocData: [{ uid: fileListOcr?.[0]?.uid, type: fileListOcr?.[0]?.response?.response?.contentType, url: fileListOcr?.[0]?.response?.response?.location }] || [{}],
    };
    return grnData;
  };

  const formatDate = (date) => {
    // Check if the date is valid
    if (dayjs(date).isValid()) {
      return dayjs(date).format('DD-MM-YYYY');
    }
    // If date is invalid, return today's date
    return dayjs().format('DD-MM-YYYY');
  };

  // transform data for create so
  const transformDataForCreateSo = (ocrData) => {
    getInventoryLocations(user?.tenant_info?.default_store_id, '', null, true);
    const soData = {
      tenant_id: user?.tenant_info?.tenant_id,
      invoice_date: dayjs(grnDate).format('DD-MM-YYYY'),
      gst_number: gstNumber,
      tenantDepartmentId: ocrData?.[0]?.tenantDepartmentId,
      ocrDocData: [{ uid: fileListOcr?.[0]?.uid, type: fileListOcr?.[0]?.response?.response?.contentType, url: fileListOcr?.[0]?.response?.response?.location }] || [{}],
      delivery_date: deliveryDate ? formatDate(deliveryDate) : formatDate(dayjs()),
      order_date: orderDate ? formatDate(orderDate) : formatDate(dayjs()),
      selectedCustomer: ocrData?.[0]?.customer_details?.newCustomer,
      shippingAddress,
      billingAddress,
      linesData: ocrData?.[0]?.data?.map((item) => ({
        ...item?.product_sku_info,
        quantity: item?.quantity || 0,
        offer_price: item?.unit_price,
        old_orc_data: item?.old_orc_data,
        received_qty: item?.quantity || 0,
        product_info: item?.product_sku_info?.product_sku_info || item?.product_sku_info?.product_info,
        selectedLocation: selectedLocation?.inventory_location,
      })),
    };
    return soData;
  };

  // Handle the collapse change event
  const handleCollapseChange = (key) => {
    if (successStep?.length) {
      // Get the last item from the key array
      const lastKey = key[key.length - 1];

      // Find the maximum step that is completed
      const maxSuccessStep = Math.max(...successStep);

      // Allow opening the current step and the next one
      if (lastKey <= maxSuccessStep + 1) {
        setActiveKey(key[key.length - 1]);
      } else {
        // Filter keys to include up to the maximum success step plus one
        const filteredKeys = key.filter((k) => k <= maxSuccessStep + 1);
        setActiveKey(filteredKeys);
      }
    }
  };

  // mapping vendor data automatically and purchase order data
  const getTableDataForVendorMapping = () => {
    setDataFromOCR((prevDataFromOCR) => {
      if (!prevDataFromOCR?.[0]?.isUserReady) {
        const vendorData = prevDataFromOCR?.map((item) => ({
          ...item,
          key: uuidv4(),
          isUserReady: true,
          mapped: !!item?.sellerData?.tenant_seller_id,
          seller_details: {
            ...item?.seller_details,
            selectedSeller: item?.sellerData?.tenant_seller_id,
            newSeller: item?.sellerData,
          },
          selectedPo,
          tenantDepartmentId: selectedPo?.tenant_department_id || user?.tenant_info?.default_store_id,
        }));
        return vendorData;
      }
      return prevDataFromOCR;
    });
  };

  // mapping customer data automatically and purchase order data
  const getTableDataForCustomerMapping = () => {
    setDataFromOCR((prevDataFromOCR) => {
      if (!prevDataFromOCR?.[0]?.isUserReady) {
        const customerData = prevDataFromOCR?.map((item) => ({
          ...item,
          key: uuidv4(),
          isUserReady: true,
          mapped: !!item?.customerData?.customer_id,
          customer_details: {
            ...item?.customer_details,
            selectedCustomer: item?.customerData?.customer_id,
            newCustomer: item?.customerData,
          },
        }));
        return customerData;
      }
      return prevDataFromOCR;
    });
  };

  useEffect(() => {
    getTableDataForVendorMapping();
  }, [call]);

  useEffect(() => {
    getTableDataForCustomerMapping();
  }, [callCustomer]);

  // Function to make product entries unique
  function makeUnique(ocrData) {
    // Create a map to track unique tenant_product_ids
    const productMap = new Map();

    // Iterate over the data array
    ocrData.data.forEach((product) => {
      if (!productMap.has(product.tenant_product_id)) {
        // If the product ID is not in the map, add it
        productMap.set(product.tenant_product_id, product);
      }
    });

    // Convert the map values back to an array
    const uniqueProducts = Array.from(productMap.values());

    // Replace the data array in the ocrData object with the unique products
    ocrData.data = uniqueProducts;

    return ocrData;
  }

  // row render content for grn
  const expandedRowRenderContentForGrn = (
    <React.Fragment>
      <div
        className="vendor-address_ocr"
      >
        <H3Text text="Select Order" className="create-grn__input-row__label" />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            gap: '5px',
            cursor: 'pointer',
            marginBottom: '10px',
          }}
        >
          <Tooltip
            className="settings-info-tooltip"
            color="rgb(240, 240, 240)"
            title={(
              <span
                className="settings-info-tooltip-text"
                style={{
                  color: 'black',
                }}
              >
                If you did not select any purchase order, then ADHOC grn will be created.
              </span>
            )}
          >
            <span
              style={{
                fontSize: '12px',
                color: 'rgb(45, 124, 246)',
              }}
              className="settings-info-tooltip-icon"
            >
              <FontAwesomeIcon icon={faCircleInfo} />
            </span>
          </Tooltip>
          <PRZSelect
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            placeholder="Select purchase order.."
            labelInValue
            filterOption={false}
            showSearch
            value={selectedPoValue}
            allowClear
            onChange={(value) => {
              const selectedPurchaseOrderCopy = purchaseOrdersV2?.purchase_order?.filter(
                (item) => Number(item.po_id) === Number(value?.key),
              );
              setSelectedPoValue(value);
              setSelectedPo(selectedPurchaseOrderCopy?.[0]);
              if (selectedPurchaseOrderCopy?.[0]) {
                const updatedData = dataFromOCR?.map((item) => {
                  const copyData = JSON.parse(JSON.stringify(item.data));
                  const newData = copyData?.map((product) => {
                    const selectedPurchaseOrderLine = selectedPurchaseOrderCopy?.[0]?.purchase_order_lines?.find(
                      (line) => line.product_sku_name === product.product_name,
                    );
                    if (selectedPurchaseOrderLine) {
                      return {
                        ...product,
                        product_sku_info: selectedPurchaseOrderLine,
                        mapped: true,
                      };
                    }
                    return product;
                  });
                  return {
                    ...item,
                    data: newData,
                  };
                });
                setDataFromOCR(updatedData);
              }
            }}
          >
            {purchaseOrdersV2 && purchaseOrdersV2?.purchase_order && purchaseOrdersV2?.purchase_order
              ?.filter((item) => item?.closing_status !== 'CLOSED')
              .map((item) => (
                <Option key={item.po_id} value={JSON.stringify(item)}>
                  {`#${item.po_number} (${toISTDate(item.created_date).format('DD/MM/YYYY')}) - ${MONEY((item.po_grand_total), item?.org_currency_info?.currency_code)}`}
                </Option>
              ))}
          </PRZSelect>

        </div>
      </div>
      {/* date  */}
      <div
        className="vendor-address_ocr"
      >
        <H3Text text="Invoice Date" className="create-grn__input-row__label" />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '85%',
            gap: '5px',
            cursor: 'pointer',
            marginBottom: '10px',
          }}
        >
          <DatePicker
            value={dayjs(grnDate, 'DD-MM-YYYY')}
            onChange={(value) => {
              setGrnDate(value);
            }}
            disabledDate={
              (d) => !d
                || (user?.tenant_info?.purchase_config?.sub_modules?.goods_receiving_note?.settings?.allow_future_date_grn ? null : d.isAfter(dayjs().add(1, 'days').format('YYYY-MM-DD')))
                || (user?.tenant_info?.purchase_config?.sub_modules?.goods_receiving_note?.settings?.allow_past_date_grn ? null : d.isSameOrBefore(dayjs().format('YYYY-MM-DD')))
            }
            style={{
              border: '1px solid rgba(68, 130, 218, 0.2)',
              borderRadius: '2px',
              height: '32px',
              padding: '1px 3px',
              width: '100%',
              background: 'white',
            }}
            format="DD-MM-YYYY"
            allowClear={false}
          />

        </div>
      </div>
      {/* vendor address */}
      <div
        className="vendor-address_ocr"
      >
        <H3Text
          text="Vendor Address"
          className="create-grn__input-row__label"
        />
        <div className="ocr-to-grn__address__wrapper">
          <div className="create-grn__input-row__address">
            {vendorAddress && (
              <div className="ocr-to-grn__address-info">
                <div className="create-grn__input-row__address-l1">
                  {vendorAddress?.address1}
                </div>
                <div className="create-grn__input-row__address-l2">
                  {`${vendorAddress?.city}, ${vendorAddress?.state}, ${vendorAddress?.postal_code}, ${vendorAddress?.country}`}
                </div>
              </div>
            )}
            {!vendorAddress && (
              <H3Text
                text="Select address.."
                className="create-grn__input-row__address-placeholder"
              />
            )}
            <div
              className="create-grn__input-row__address-icon"
              onClick={() => {
                setSelectedAddressType('SELLER');
                setShowAddressDrawer(true);
              }}
            >
              <EditFilled />
              {' '}
              Update
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
        }}
        className="vendor-address_ocr"
        onClick={() => {
          if (selectedPoValue || isAdhocGrnIsEnabled) {
            setActiveKey(3);
            setSuccessStep([1, 2]);
          }
        }}
      >
        <div
          style={{
            marginTop: '-3px',
          }}
        >
          {!isAdhocGrnIsEnabled && !selectedPoValue && (
            <SettingsInfo
              settingName="Allow users to create adhoc grn"
              path="/settings/business-profile"
            />
          )}
        </div>
        <H3Text
          text="Move to next step ->"
          className="create-grn__input-row__label color_update"
        />
      </div>

    </React.Fragment>
  );

  // row render content for so
  const expandedRowRenderContentForSo = (
    <React.Fragment>
      {/* delivery date */}
      <div className="vendor-address_ocr">
        <H3Text text="Delivery Date" className="create-grn__input-row__label" />
        <div
          className="create-grn__data-row__input"
        >
          <DatePicker
            value={dayjs(deliveryDate, 'DD-MM-YYYY')}
            onChange={(value) => {
              setDeliveryDate(value);
            }}
            className="date-picker"
            format="DD-MM-YYYY"
            allowClear={false}
          />

        </div>
      </div>
      {/* order date */}
      <div className="vendor-address_ocr">
        <H3Text text="Order Date" className="create-grn__input-row__label" />
        <div
          className="create-grn__data-row__input"
        >
          <DatePicker
            value={dayjs(orderDate, 'DD-MM-YYYY')}
            onChange={(value) => {
              setOrderDate(value);
            }}
            className="date-picker"
            format="DD-MM-YYYY"
            allowClear={false}
          />

        </div>
      </div>
      {/* shipping address */}
      <div
        className="vendor-address_ocr"
        style={{
          marginBottom: '10px',
        }}
      >
        <div>
          <H3Text
            text="Shipping Address"
            className="create-grn__input-row__label"
          />
        </div>
        <div className="ocr-to-grn__address__wrapper">
          <div className="create-grn__input-row__address">
            {shippingAddress && (
              <div className="ocr-to-grn__address-info">
                <div className="create-grn__input-row__address-l1">
                  {shippingAddress?.address1}
                </div>
                <div className="create-grn__input-row__address-l2">
                  {`${shippingAddress?.city}, ${shippingAddress?.state}, ${shippingAddress?.postal_code}, ${shippingAddress?.country}`}
                </div>
              </div>
            )}
            {!shippingAddress && (
              <H3Text
                text="Select address.."
                className="create-grn__input-row__address-placeholder"
              />
            )}
            <div
              className="create-grn__input-row__address-icon"
              onClick={() => {
                setSelectedAddressType('TENANT_SHIPPING');
                setShowAddressDrawer(true);
              }}
            >
              <EditFilled />
              {' '}
              Update
            </div>
          </div>
        </div>
      </div>
      {/* billing address */}
      <div className="vendor-address_ocr">
        <div>
          <H3Text
            text="Billing Address"
            className="create-grn__input-row__label"
          />
        </div>
        <div className="ocr-to-grn__address__wrapper">
          <div className="create-grn__input-row__address">
            {billingAddress && (
              <div className="ocr-to-grn__address-info">
                <div className="create-grn__input-row__address-l1">
                  {billingAddress?.address1}
                </div>
                <div className="create-grn__input-row__address-l2">
                  {`${billingAddress?.city}, ${billingAddress?.state}, ${billingAddress?.postal_code}, ${billingAddress?.country}`}
                </div>
              </div>
            )}
            {!billingAddress && (
              <H3Text
                text="Select address.."
                className="create-grn__input-row__address-placeholder"
              />
            )}
            <div
              className="create-grn__input-row__address-icon"
              onClick={() => {
                setSelectedAddressType('TENANT_BILLING');
                setShowAddressDrawer(true);
              }}
            >
              <EditFilled />
              {' '}
              Update
            </div>
          </div>
        </div>
      </div>
      <div
        className="vendor-address_ocr"
        onClick={() => {
          setActiveKey(3);
          setSuccessStep([1, 2]);
        }}
      >
        <H3Text
          text="Move to next step ->"
          className="create-grn__input-row__label color_update"
        />
      </div>
    </React.Fragment>
  );

  const handleUploadChange = (fileListData) => {
    const updatedFileList = fileListData?.fileList?.map((item) => ({
      ...item,
      url: item?.response?.response?.location || item?.url,
    }));

    setFileListOcr(updatedFileList);

    if (updatedFileList.length === 0) {
      setSuccessStep([]);
      return;
    }

    const payload = {
      tenant_id: user?.tenant_info?.tenant_id,
      entity_name: entityName,
      url: fileListData.file?.response?.response?.location || fileListData.file?.url,
    };

    if (fileListData.file?.response?.response?.location || fileListData.file?.url) {
      uploadDocumentOCR(payload, (ocrData) => {
        const _ocrData = (ocrData);
        const sellerName = _ocrData?.seller_details?.seller_info?.seller_name;
        const customerName = _ocrData?.customer_details?.customer_name;
        const productSkuIds = _ocrData?.data?.map((item) => item?.product_info?.product_sku_info?.product_sku_id).join(',');

        if (sellerName) {
          getSellers(sellerName, user?.tenant_info?.tenant_id, 1, 1000, '', (data) => {
            setDataFromOCR([{ ..._ocrData, sellerData: data?.sellers?.[0] }] || []);
            setVendorAddress(data?.sellers?.[0]?.seller_info?.office_address_details);
            setGrnDate(dayjs(_ocrData?.invoice_date) || dayjs().format('DD-MM-YYYY'));
            getPurchaseOrdersV2({
              query: {
                org_id: user?.tenant_info?.org_id,
                tenant_id: user?.tenant_info?.tenant_id,
                tenant_seller_id: data?.sellers?.[0]?.tenant_seller_id,
                status: 'ISSUED',
                page: 1,
                limit: 30,
              },
            }, (searchedPo) => {
              const selectedPurchaseOrderCopy = searchedPo?.purchase_order?.find(
                (item) => item.po_number === _ocrData?.po_number,
              );
              setSelectedPoValue(selectedPurchaseOrderCopy ? JSON.stringify(selectedPurchaseOrderCopy) : null);
              setSelectedPo(selectedPurchaseOrderCopy);
              setCall(!call);
              if (selectedPurchaseOrderCopy) {
                const updatedData = _ocrData?.data?.map((product) => {
                  const selectedPurchaseOrderLine = selectedPurchaseOrderCopy?.purchase_order_lines?.find(
                    (line) => line.product_sku_name === product.product_name,
                  );
                  if (selectedPurchaseOrderLine) {
                    return {
                      ...product,
                      product_sku_info: selectedPurchaseOrderLine,
                      mapped: true,
                    };
                  }
                  return product;
                });
                setDataFromOCR([{ ..._ocrData, data: updatedData, sellerData: data?.sellers?.[0] }]);
                setCall(!call);
              }
            });
            // getPurchaseOrders(user?.tenant_info?.org_id, user?.tenant_info?.tenant_id, data?.sellers?.[0]?.tenant_seller_id, '', '', '', '', 'ISSUED', 1, 30, '', (searchedPo) => {
            //   const selectedPurchaseOrderCopy = searchedPo?.purchase_order?.find(
            //     (item) => item.po_number === _ocrData?.po_number,
            //   );
            //   setSelectedPoValue(selectedPurchaseOrderCopy ? JSON.stringify(selectedPurchaseOrderCopy) : null);
            //   setSelectedPo(selectedPurchaseOrderCopy);
            //   setCall(!call);
            //   if (selectedPurchaseOrderCopy) {
            //     const updatedData = _ocrData?.data?.map((product) => {
            //       const selectedPurchaseOrderLine = selectedPurchaseOrderCopy?.purchase_order_lines?.find(
            //         (line) => line.product_sku_name === product.product_name,
            //       );
            //       if (selectedPurchaseOrderLine) {
            //         return {
            //           ...product,
            //           product_sku_info: selectedPurchaseOrderLine,
            //           mapped: true,
            //         };
            //       }
            //       return product;
            //     });
            //     setDataFromOCR([{ ..._ocrData, data: updatedData, sellerData: data?.sellers?.[0] }]);
            //     setCall(!call);
            //   }
            // });
          }, true, '', '', '');
        }
        if (customerName) {
          getCustomers(customerName, user?.tenant_info?.tenant_id, 1, 1000, '', (customerData) => {
            setDataFromOCR([{ ..._ocrData, customerData: customerData?.customers?.[0] }] || []);
            setDeliveryDate(_ocrData?.delivery_date ? dayjs(_ocrData?.delivery_date) : dayjs().format('DD-MM-YYYY'));
            setOrderDate(_ocrData?.order_date ? dayjs(_ocrData?.order_date) : dayjs().format('DD-MM-YYYY'));
            setShippingAddress(customerData?.customers?.[0]?.customer_info?.shipping_address_details);
            setBillingAddress(customerData?.customers?.[0]?.customer_info?.billing_address_details);
            if (productSkuIds) {
              searchProducts({
                tenantId: user?.tenant_info?.tenant_id,
                productSkuIds,
              }, '', (searchProductsData) => {
                const updatedData = _ocrData?.data?.map((product) => {
                  const selectedProduct = searchProductsData?.find(
                    (item) => item.product_sku_id === product?.product_info?.product_sku_info?.product_sku_id,
                  );
                  if (selectedProduct) {
                    return {
                      ...product,
                      product_sku_info: selectedProduct,
                      mapped: true,
                      ...selectedProduct,
                      product_sku_name: selectedProduct?.alias_name || selectedProduct?.product_name,
                    };
                  }
                  return product;
                });
                setDataFromOCR([{ ..._ocrData, data: updatedData, customerData: customerData?.customers?.[0] }]);
                setCallCustomer(!callCustomer);
              });
            }
          });
        }
        setActiveKey(2);
        setSuccessStep([1]);
      });
    }
  };

  const columnForProductMapping = [
    {
      title: '',
      fixed: 'left',
      width: '50px',
      render: (text, record) => (
        <Popconfirm title="Are you sure you want to remove this item?" onConfirm={() => handleDelete(record?.key, record?.grn_line_id)}>
          <div className="delete-line-button__new" style={{ marginLeft: 'auto' }}>
            <FontAwesomeIcon icon={faTrashCan} />
          </div>
        </Popconfirm>
      ),
    },
    {
      title: 'Product Name in Document',
      width: '200px',
      key: 'product_vendor_name',
      render: (record) => (
        <div style={{ textAlign: 'left' }}>
          {record?.product_name || 'N/A'}
        </div>
      ),
    },
    {
      width: '60px',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <div className="bulk-import__status-icon" style={{ textAlign: 'center' }}>
          {record?.mapped ? <FontAwesomeIcon icon={faCircleCheck} color="#1AC05D" /> : <FontAwesomeIcon icon={faTriangleExclamation} color="#dcaa06" />}
        </div>
      ),
    },
    {
      title: 'Product Name in Procuzy',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      width: '200px',
      render: (record) => {
        const optionForMappingProduct = selectedPo?.purchase_order_lines;
        return (
          <Fragment>
            {!optionForMappingProduct ? (
              <ProductFilterV2
                customClass="product_selector"
                record={{
                  ...record,
                  internal_sku_code: record?.product_sku_info?.internal_sku_code,
                  ref_product_code: record?.product_sku_info?.ref_product_code,
                }}
                required
                isTextarea
                isPurchaseProduct
                productTypes={['STORABLE', 'SERVICE', 'NON_STORABLE']}
                handleProductChangeValue={(value, key, newData) => { }}
                handleProductChange={handleProductChange}
                onClear={(key) => handleProductChange(null, key)}
                showClear
                searchKeywordID={record?.product_name}
              />

            ) : (
              <PRZSelect
                placeholder="Select product.."
                labelInValue
                showSearch
                filterOption={false}
                value={record?.product_sku_info?.product_sku_name}
                style={{
                  width: '250px',
                }}
                allowClear
                onChange={(value) => {
                  const selectedPurchaseOrderCopy = optionForMappingProduct?.filter(
                    (item) => item.product_sku_id === Number(value?.key),
                  );
                  handleProductChange(selectedPurchaseOrderCopy?.[0], record?.product_name);
                }}
              >
                {optionForMappingProduct
                  ?.filter((item) => !selectedOptions.includes(item?.product_sku_id))
                  ?.map((item) => (
                    <Option key={item?.product_sku_id} value={JSON.stringify(item?.product_sku_info)}>
                      {item?.product_sku_info?.product_sku_name}
                    </Option>
                  ))}
              </PRZSelect>
            )}
          </Fragment>
        );
      },
    },
  ];
  // mapping vendor data automatically and purchase order data in case of grn
  const columnForVendorMapping = [
    {
      title: 'Vendor in Document',
      key: 'vendor_name',
      width: '150px',
      render: (record) => (
        <div style={{ textAlign: 'left' }}>
          {record?.seller_details?.seller_info?.seller_name || 'N/A'}
        </div>
      ),
    },
    {
      width: '60px',
      key: 'mapped',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <div className="bulk-import__status-icon" style={{ textAlign: 'center' }}>
          {record?.mapped ? <FontAwesomeIcon icon={faCircleCheck} color="#1AC05D" /> : <FontAwesomeIcon icon={faTriangleExclamation} color="#dcaa06" />}
        </div>
      ),
    },
    {
      title: 'Procuzy Vendor',
      key: 'procuzy_vendor_name',
      width: '250px',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <SelectSeller
          key={record?.seller_details?.tenant_seller_id}
          selectedSeller={record?.seller_details?.selectedSeller}
          onChange={(value) => {
            if (value) {
              const updatedData = dataFromOCR?.map((item) => ({
                ...item,
                mapped: true,
                seller_details: {
                  ...item.seller_details,
                  selectedSeller: value?.tenant_seller_id,
                  newSeller: value,
                },
              }));
              setDataFromOCR(updatedData);
              setVendorAddress(value?.seller_info?.office_address_details);
              setGstNumber(value?.seller_info?.gst_number);
              setGrnDate(dayjs(updatedData?.[0]?.invoice_date) || dayjs().format('DD-MM-YYYY'));
              // getPurchaseOrders(user?.tenant_info?.org_id, record?.tenant_id || user?.tenant_info?.tenant_id, value?.tenant_seller_id, '', '', '', '', 'ISSUED', 1, 30);
              getPurchaseOrdersV2({
                query: {
                  org_id: user?.tenant_info?.org_id,
                  tenant_id: record?.tenant_id || user?.tenant_info?.tenant_id,
                  tenant_seller_id: value?.tenant_seller_id,
                  status: 'ISSUED',
                  page: 1,
                  limit: 30,
                },
              });
              setSelectedPoValue(null);
            } else {
              const updatedData = dataFromOCR.map((item) => ({
                ...item,
                mapped: false,
                seller_details: {
                  ...item.seller_details,
                  selectedSeller: null,
                  newSeller: null,
                },
              }));
              setDataFromOCR(updatedData);
            }
          }}
          containerClass="create-po__input-row"
          inputClassName=" create-po-seller__selector create-po__input-row__input"
          labelClassName="create-po__input-row__label"
          showAddVendor
          hideTitle
          tenantId={record?.tenant_id || user?.tenant_info?.tenant_id}
        />
      ),
    },
  ];
  // mapping customer data automatically in case of so
  const columnForCustomerMapping = [
    {
      title: 'Customer in Document',
      key: 'vendor_name',
      width: '150px',
      render: (record) => (
        <div style={{ textAlign: 'left' }}>
          {record?.customer_details?.customer_name || 'N/A'}
        </div>
      ),
    },
    {
      width: '60px',
      key: 'mapped',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <div className="bulk-import__status-icon" style={{ textAlign: 'center' }}>
          {record?.mapped ? <FontAwesomeIcon icon={faCircleCheck} color="#1AC05D" /> : <FontAwesomeIcon icon={faTriangleExclamation} color="#dcaa06" />}
        </div>
      ),
    },
    {
      title: 'Procuzy Customer',
      key: 'procuzy_vendor_name',
      width: '250px',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <SelectCustomer
          key={record?.customer_details?.customer_id}
          selectedCustomer={record?.customer_details?.selectedCustomer}
          hideTitle
          onChange={(value) => {
            if (value) {
              const updatedData = dataFromOCR?.map((item) => ({
                ...item,
                mapped: true,
                customer_details: {
                  ...item.customer_details,
                  selectedCustomer: value?.customer_id,
                  newCustomer: value,
                },
              }));
              setDataFromOCR(updatedData);
              setShippingAddress(value?.customer_info?.shipping_address_details);
              setBillingAddress(value?.customer_info?.billing_address_details);
            } else {
              const updatedData = dataFromOCR.map((item) => ({
                ...item,
                mapped: false,
                customer_details: {
                  ...item.customer_details,
                  selectedCustomer: null,
                  newCustomer: null,
                },
              }));
              setDataFromOCR(updatedData);
            }
          }}
          tenantId={record?.tenant_id || user?.tenant_info?.tenant_id}
          containerClass="create-po__input-row"
        />
      ),
    },
  ];
  return (
    <div className="ocr-steps-main-container">
      <Drawer
        open={showAddressDrawer}
        onClose={() => {
          setShowAddressDrawer(false);
          setSelectedAddressType('');
        }}
        width="360"
        destroyOnClose
      >
        <AddressSelector
          title={selectedAddressType === 'SELLER' ? 'Vendor Address' : selectedAddressType === 'TENANT_SHIPPING' ? 'Shipping Address' : 'Billing Address'}
          addressType={selectedAddressType?.split('_')[0]}
          selectedAddressId={selectedAddressType === 'SELLER' ? vendorAddress?.address_id : selectedAddressType === 'TENANT_SHIPPING' ? shippingAddress?.address_id : billingAddress?.address_id}
          onAddressChange={(address) => {
            if (selectedAddressType === 'SELLER') {
              setVendorAddress(address);
            } else if (selectedAddressType === 'TENANT_SHIPPING') {
              setShippingAddress(address);
            } else {
              setBillingAddress(address);
            }
            setShowAddressDrawer(false);
          }}
          entityId={entityName === 'invoice' ? dataFromOCR?.[0]?.seller_details?.newSeller?.seller_id : dataFromOCR?.[0]?.customer_details?.newCustomer?.customer_id}
          entityType={selectedAddressType === 'SELLER' ? 'SELLER' : 'CUSTOMER'}
          seller={dataFromOCR?.[0]?.seller_details?.newSeller?.tenant_seller_id || null}
        />
      </Drawer>
      {(uploadDocumentOCRLoading && !successStep?.includes(1)) && (<OCRLoader />)}
      <Steps direction="vertical">
        {/* first step for upload invoice */}
        <Step
          description={(
            <Fragment>
              <Collapse
                bordered={false}
                activeKey={activeKey}
                expandIcon={({ isActive }) => (
                  isActive ? (
                    <FontAwesomeIcon icon={faAngleDown} />
                  ) : (
                    <FontAwesomeIcon icon={faAngleRight} />
                  )
                )}
                style={{ background: '#00000005' }}
                onChange={handleCollapseChange}
              >
                <Panel
                  header={(
                    <div className="ocr-steps-label">
                      <H3Text
                        text={entityName === 'invoice' ? 'Upload vendor invoice' : 'Upload customer purchase order'}
                        className="ocr-steps-label-title"
                      />
                      {successStep?.includes(1) ? <FontAwesomeIcon icon={faCircleCheck} style={{ color: '#0ec311', marginLeft: '3px' }} /> : ''}
                    </div>
                  )}
                  key="1"
                >
                  <div className="ocr-upload__step-details">
                    {isOcrIsPremiumFeature ? (
                      <React.Fragment>
                        <label className="orc-upload-invoice__form-label">
                          {`Please upload ${entityName === 'invoice' ? 'vendor invoice' : 'customer purchase order'} in PDF/JPG/PNG format`}
                          <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dragger
                          action={Constants.UPLOAD_FILE}
                          fileList={fileListOcr || []}
                          multiple={false}
                          beforeUpload={(file) => {
                            if (fileListOcr && fileListOcr.length > 0) {
                              notification.open({
                                type: 'error',
                                message: 'Please delete the existing file before uploading a new one.',
                                duration: 4,
                                placement: 'top',
                              });
                              return Upload.LIST_IGNORE;
                            }
                            return true;
                          }}
                          onChange={handleUploadChange}
                        >
                          <Fragment>
                            <p className="ant-upload-drag-icon">
                              <InboxOutlined />
                            </p>
                            <p className="ant-upload-text" style={{ fontSize: '13px !important' }}>
                              Click or drag file to this area to upload
                            </p>
                            <p className="ant-upload-hint">
                              (Supported formats .pdf,.jpg,.png; max file size 5 MB)
                            </p>
                          </Fragment>
                        </Dragger>
                      </React.Fragment>
                    ) : (
                      <div className="upload-disabled">
                        <Lottie
                          animationData={restrictedLock}
                          loop
                          style={{
                            width: '40%',
                            height: '40%',
                          }}
                        />
                        <p className="ant-upload-text" style={{ fontSize: '16px', fontWeight: '500' }}>
                          Premium Feature
                        </p>
                        <p className="ant-upload-hint">
                          Automatic document scanning feature is not available in your current plan.
                        </p>
                        <div className="restricted-contact-button__wrapper">
                          <div
                            className="restricted-contact-button"
                            onClick={() => window.Intercom('showNewMessage')}
                          >
                            Contact Us
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Panel>
              </Collapse>
            </Fragment>
          )}
        />
        {/* second step for validate vendor info */}
        <Step
          description={(
            <Fragment>
              <Collapse
                bordered={false}
                expandIcon={({ isActive }) => (
                  isActive ? (
                    <FontAwesomeIcon icon={faAngleDown} />
                  ) : (
                    <FontAwesomeIcon icon={faAngleRight} />
                  )
                )}
                style={{ background: '#00000005' }}
                activeKey={activeKey}
                onChange={handleCollapseChange}
              >
                <Panel
                  header={(
                    <div className="ocr-steps-label">
                      <H3Text
                        text={entityName === 'invoice' ? 'Validate vendor information' : 'Validate customer information'}
                        className="ocr-steps-label-title"
                      />
                      {(successStep?.includes(2)) ? <FontAwesomeIcon icon={faCircleCheck} style={{ color: '#0ec311', marginLeft: '3px' }} /> : ''}
                    </div>
                  )}
                  key="2"
                >
                  <Table
                    showHeader
                    size="small"
                    scroll={{ x: 'max-content' }}
                    columns={entityName === 'invoice' ? columnForVendorMapping : columnForCustomerMapping}
                    bordered={false}
                    dataSource={dataFromOCR || []}
                    pagination={false}
                    expandable={{
                      expandedRowKeys: [
                        ...(dataFromOCR?.filter((item) => item?.seller_details?.selectedSeller).map((item) => item?.key) || []),
                        ...(dataFromOCR?.filter((item) => item?.customer_details?.selectedCustomer).map((item) => item?.key) || []),
                      ],
                      rowExpandable: (record) => (!!record.seller_details?.selectedSeller || !!record.customer_details?.selectedCustomer),
                      expandedRowRender: () => (entityName === 'invoice' ? expandedRowRenderContentForGrn : expandedRowRenderContentForSo),
                    }}
                  />
                </Panel>
              </Collapse>
            </Fragment>
          )}
        />
        {/* third step for validate product info */}
        <Step
          description={(
            <Fragment>
              <Collapse
                activeKey={activeKey}
                bordered={false}
                expandIcon={({ isActive }) => (
                  isActive ? (
                    <FontAwesomeIcon icon={faAngleDown} />
                  ) : (
                    <FontAwesomeIcon icon={faAngleRight} />
                  )
                )}
                style={{ background: '#00000005' }}
                onChange={handleCollapseChange}
              >
                <Panel
                  header={(
                    <div className="ocr-steps-label">
                      <H3Text
                        text="Validate product information"
                        className="ocr-steps-label-title"
                      />
                    </div>
                  )}
                  key="3"
                >
                  <Table
                    showHeader
                    size="small"
                    scroll={{ x: 'max-content' }}
                    columns={columnForProductMapping || []}
                    bordered={false}
                    // dataSource={
                    //   dataFromOCR?.[0]?.data?.reduce((acc, item) => {
                    //     if (!acc.find(({ product_name }) => product_name === item.product_name)) {
                    //       acc.push({ ...item, key: item.product_name });
                    //     }
                    //     return acc;
                    //   }, []) || []
                    // }
                    dataSource={dataFromOCR[0]?.data?.map((item) => ({
                      ...item,
                      key: item?.product_name,
                    })) || []}
                    pagination={false}
                  />
                </Panel>
              </Collapse>
            </Fragment>
          )}
        />
      </Steps>
      {
        dataFromOCR?.[0]?.data?.every((item) => item.product_sku_info) && (
          <div
            className="goods-receiving__ocr-button-container"
          >
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text={(
                <React.Fragment>
                  <img className="ai-icon-for-ocr" style={{ filter: 'none' }} src={Ai} alt="premium" />
                  {' '}
                  {/* Create Goods Receiving */}
                  {entityName === 'invoice' ? 'Create Goods Receiving' : `Create ${documentUINames.salesOrderUIName}`}
                </React.Fragment>
              )}
              onClick={() => {
                if (entityName === 'invoice') {
                  const dataForGrn = transformDataForCreateGRN(dataFromOCR);
                  history.push({
                    pathname: '/purchase/goods-receiving/create',
                    state: {
                      dataForGrn,
                    },
                  });
                } else {
                  const dataForSo = transformDataForCreateSo(dataFromOCR);
                  history.push({
                    pathname: '/sales/sales-orders/create',
                    state: {
                      dataFromOcrToSo: dataForSo,
                    },
                  });
                }
              }}
              customClass="goods-receiving__ocr-button"
            />
          </div>
        )
      }
    </div>
  );
};
const mapStateToProps = ({
  UserReducers, OCRReducers, PurchaseOrderReducers, ProductReducers, GetPurchaseOrders
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  uploadDocumentOCRLoading: OCRReducers.uploadDocumentOCRLoading,
  searchProductsLoading: ProductReducers.searchProductsLoading,
  purchaseOrdersV2: GetPurchaseOrders.data,
  getPurchaseOrdersV2Loading: GetPurchaseOrders.loading,
});

const mapDispatchToProps = (dispatch) => ({
  searchProducts: (params, callback, newCallback) => dispatch(ProductActions.searchProducts(params, callback, newCallback)),
  getCustomers: (keyword, tenantId, page, limit, customerId, callback) => dispatch(CustomerActions.getCustomers(keyword, tenantId, page, limit, customerId, callback)),
  getInventoryLocations: (tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId, departmentId, callback) => dispatch(inventoryLocationActions.getInventoryLocations(tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId, departmentId, callback)),
  uploadDocumentOCR: (payload, action) => dispatch(OCRActions.uploadDocumentOCR(payload, action)),
  getSellers: (keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType, isMarketplaceSeller) => dispatch(
    SellerActions.getSellers(keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType, isMarketplaceSeller),
  ),
  getPurchaseOrdersV2: (payload, callback) => dispatch(GetPurchaseOrders.actions.request(payload, callback)),
});

OCRFileUploader.propTypes = {
  user: PropTypes.any,
  uploadDocumentOCR: PropTypes.func,
  uploadDocumentOCRLoading: PropTypes.bool,
  MONEY: PropTypes.any,
  history: PropTypes.any,
  getInventoryLocations: PropTypes.func,
  getSellers: PropTypes.func,
  searchProductsLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OCRFileUploader));
